module.exports = __webpack_public_path__ + "static/soul_rebel-e49869b81ea83b97b0fed03844c8df2c.png";